<template>
  <div id="app">
    <Header />
    <router-view :class="$style.content" />
    <Footer />
  </div>
</template>

<script lang="ts">
import Header from "@/components/organsms/Header.vue";
import Footer from "@/components/organsms/Footer.vue";

export default {
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="scss" module>
@import url("https://fonts.googleapis.com/css?family=Kosugi+Maru&display=swap");
@import url("https://fonts.googleapis.com/css?family=Noto+Serif+JP&display=swap");
#app,
body {
  margin: 0;
  .content {
    position: relative !important;
  }
}
@media only screen and (max-width: 1023px) {
  #app,
  body {
    font-family: "Noto Serif JP", serif !important;
  }
}
@media only screen and (min-width: 1024px) {
  #app,
  body {
    font-family: "Kosugi Maru", sans-serif !important;
  }
}
</style>
